import { isSemanticModelClassProfile, isSemanticModelRelationshipProfile, SEMANTIC_MODEL_CLASS_PROFILE, SEMANTIC_MODEL_RELATIONSHIP_PROFILE, } from "../concepts/index.js";
import { isCreateSemanticModelClassProfile, isModifySemanticModelClassProfile, isCreateSemanticModelRelationshipProfile, isModifySemanticModelRelationshipProfile } from "./operations.js";
class DefaultSemanticModelProfileOperationExecutor {
    identifierSource;
    entityReader;
    entityWriter;
    constructor(identifierSource, entityReader, entityWriter) {
        this.identifierSource = identifierSource;
        this.entityReader = entityReader;
        this.entityWriter = entityWriter;
    }
    executeOperation(operation) {
        if (isCreateSemanticModelClassProfile(operation)) {
            return executeCreateSemanticModelClassProfile(this.identifierSource, this.entityWriter, operation);
        }
        if (isModifySemanticModelClassProfile(operation)) {
            return executeModifySemanticModelClassProfile(this.entityReader, this.entityWriter, operation);
        }
        if (isCreateSemanticModelRelationshipProfile(operation)) {
            return executeCreateSemanticModelRelationshipProfile(this.identifierSource, this.entityWriter, operation);
        }
        if (isModifySemanticModelRelationshipProfile(operation)) {
            return executeModifySemanticModelRelationshipProfile(this.entityReader, this.entityWriter, operation);
        }
        return null;
    }
}
function executeCreateSemanticModelClassProfile(identifierSource, entityWriter, { entity }) {
    const identifier = identifierSource.createIdentifier();
    const newEntity = {
        ...entity,
        id: identifier,
        type: [SEMANTIC_MODEL_CLASS_PROFILE],
    };
    entityWriter.change({ [identifier]: newEntity }, []);
    return {
        success: true,
        created: [identifier],
    };
}
function executeModifySemanticModelClassProfile(entityReader, entityWriter, { identifier, entity }) {
    const previous = entityReader.entity(identifier);
    if (previous === null || !isSemanticModelClassProfile(previous)) {
        console.error("Previous values is not class profile, action to update the profile is ignored.", { previous, next: entity });
        return {
            success: false,
            created: [],
        };
    }
    ;
    const updatedEntity = {
        // The actual entity can be more specialized than SemanticModelClassProfile
        ...previous,
        id: identifier,
        type: [SEMANTIC_MODEL_CLASS_PROFILE],
        description: entity.description ?? previous.description,
        descriptionFromProfiled: mergeFromProfiled(entity.descriptionFromProfiled, previous.descriptionFromProfiled),
        name: entity.name ?? previous.name,
        nameFromProfiled: mergeFromProfiled(entity.nameFromProfiled, previous.nameFromProfiled),
        iri: entity.iri ?? previous.iri,
        usageNote: entity.usageNote ?? previous.usageNote,
        usageNoteFromProfiled: mergeFromProfiled(entity.usageNoteFromProfiled, previous.usageNoteFromProfiled),
        profiling: entity.profiling ?? previous.profiling,
        externalDocumentationUrl: mergeFromProfiled(entity.externalDocumentationUrl, previous.externalDocumentationUrl),
        tags: mergeFromProfiled(entity.tags, previous.tags),
    };
    entityWriter.change({ [identifier]: updatedEntity }, []);
    return {
        success: true,
        created: [],
    };
}
function mergeFromProfiled(next, previous) {
    // We need to store null, if next is null.
    if (next === undefined) {
        return previous;
    }
    return next;
}
function executeCreateSemanticModelRelationshipProfile(identifierSource, entityWriter, { entity }) {
    const identifier = identifierSource.createIdentifier();
    const newEntity = {
        ...entity,
        id: identifier,
        type: [SEMANTIC_MODEL_RELATIONSHIP_PROFILE],
        ends: (entity.ends ?? []).map(item => ({
            ...defaultRelationshipEndProfile(),
            ...item,
        })),
    };
    entityWriter.change({ [identifier]: newEntity }, []);
    return {
        success: true,
        created: [identifier],
    };
}
function defaultRelationshipEndProfile() {
    return {
        name: null,
        nameFromProfiled: null,
        description: null,
        descriptionFromProfiled: null,
        iri: null,
        cardinality: null,
        usageNote: null,
        usageNoteFromProfiled: null,
        profiling: [],
        externalDocumentationUrl: null,
        tags: [],
    };
}
function executeModifySemanticModelRelationshipProfile(entityReader, entityWriter, { identifier, entity }) {
    const previous = entityReader.entity(identifier);
    if (previous === null || !isSemanticModelRelationshipProfile(previous)) {
        console.error("Previous values is not relationship profile, action to update the profile is ignored.", { previous, next: entity });
        return {
            success: false,
            created: [],
        };
    }
    ;
    // When no ends are give, use the one from previous state
    const ends = entity.ends === undefined ? previous.ends :
        // Else we merge old to new, otherwise we would not be able to delete.
        entity.ends.map((value, index) => ({
            ...(previous.ends[index] ?? {}),
            ...value
        }));
    const updatedEntity = {
        // The actual entity can be more specialized than SemanticModelRelationshipProfile
        ...previous,
        id: identifier,
        type: [SEMANTIC_MODEL_RELATIONSHIP_PROFILE],
        ends,
    };
    entityWriter.change({ [identifier]: updatedEntity }, []);
    return {
        success: true,
        created: [],
    };
}
export function createDefaultSemanticModelProfileOperationExecutor(identifierSource, entityReader, entityWriter) {
    return new DefaultSemanticModelProfileOperationExecutor(identifierSource, entityReader, entityWriter);
}
//# sourceMappingURL=operations-executor.js.map